
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainRegistrantInfoModel extends Model<DomainRegistrantInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'vatNumber', type: 'string', languageString: 'domainRegistrantInfo.property.vatNumber' },
		{ name: 'companyName', type: 'string', languageString: 'domainRegistrantInfo.property.companyName' },
		{ name: 'address', type: 'string', languageString: 'domainRegistrantInfo.property.address' },
		{ name: 'postalCode', type: 'string', languageString: 'domainRegistrantInfo.property.postalCode' },
		{ name: 'city', type: 'string', languageString: 'domainRegistrantInfo.property.city' },
		{ name: 'countryCode', type: 'string', languageString: 'domainRegistrantInfo.property.countryCode' },
		{ name: 'contactName', type: 'string', languageString: 'domainRegistrantInfo.property.contactName' },
		{ name: 'email', type: 'string', languageString: 'domainRegistrantInfo.property.email' },
		{ name: 'phone', type: 'string', languageString: 'domainRegistrantInfo.property.phone' },
		{ name: 'invalidData', type: 'string[]', languageString: 'domainRegistrantInfo.property.invalidData', isArray: true }
	];
	[key: string]: any;
	
	public vatNumber: string;
	public companyName: string;
	public address: string;
	public postalCode: string;
	public city: string;
	public countryCode: string;
	public contactName: string;
	public email: string;
	public phone: string;
	public invalidData: string[];
    
	constructor(){
		super();
		this.vatNumber = '';
		this.companyName = '';
		this.address = '';
		this.postalCode = '';
		this.city = '';
		this.countryCode = '';
		this.contactName = '';
		this.email = '';
		this.phone = '';
		this.invalidData = [];
		
	}
	getProperties(){
		return DomainRegistrantInfoModel.classProperties;
	}
}

